import { Form, FormFieldType } from "../Form";

export class TicketOrganizationForm extends Form {
  protected definition = {
    dueDate: { type: FormFieldType.Date, required: true },
    priority: { type: FormFieldType.Selection, required: true }
  };
}
